import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SurveyService } from 'src/app/services/survey.service';
import { UrlService } from 'src/app/services/url.service';
import { DateHelpers } from 'src/app/utils/date.helper';
import { EncryptDecryptService } from 'src/app/utils/encrypt-decrypt.service';
import { HelperService } from 'src/app/utils/helpers';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  public form!: FormGroup<any>;

  dataquestion: any = []
  totalquestion = 0

  public formData = {
    q_satu: ''
  }

  questionpage = 1
  selectedItems: number[] = [];
  selectedOption: number[] = [];
  // selectedOption: { [linequestion: number]: string } = {};
  resultSurvey: any[] = []
  uniqueArray = Array()
  checkDataQuestionSeven: any[] = []
  errorResultSurvey: string | undefined;
  isLoading: boolean = false;

  showbuttonclaim = false

 public Ya = false
 public Tidak = false
 public showclaim = true

 refidotp: string = '';
 noclient: string = '';
 isShow: string = "";

 disablebutton = true

  constructor(
    private dateHelper: DateHelpers,
    private service: SurveyService,
    private helper: HelperService,
    private encryptDecryptService: EncryptDecryptService,
    private fb: FormBuilder,
    private url: UrlService,
    private activeRoute: ActivatedRoute,
  ) {
    this.activeRoute.queryParams.subscribe(async (d:any) => {
      this.refidotp = d.id;
      this.isShow = d.s;
    });
  }

  ngOnInit(): void {
    this.getdataquestion()
    // this.initForm()
  }

  getdataquestion() {
    const data = this.service.getquestion().subscribe((r) => {
      if (r.status === 200) {
        this.dataquestion = r.data
        this.totalquestion = r.data.length
      }
    }, (err) => {})
  }

  handleCheckboxChange(ev:any,data:any){
    if (data.id == 32) {
      this.Ya = !this.Ya
    }
    if (data.id == 33 || data.id == 34) {
      this.Tidak = !this.Tidak
    }
    if (this.selectedItems.includes(data.id)) {
      this.selectedItems = this.selectedItems.filter(item => item !== data.id);
      this.resultSurvey = this.resultSurvey.filter(item => item.id !== data.id);
    } else {
      this.selectedItems.push(data.id);
      this.resultSurvey.push(data);
    }
  }


  handleRadioChange(ev:any,data:any){
    this.selectedOption[data.linequestion] = data.id;
    this.resultSurvey = this.resultSurvey.filter(item => item.linequestion !== data.linequestion);
    this.resultSurvey.push(data);
    // if (data == 9) {
    //   this.showclaim = false;
    // }
  }

  // handleEssayChange(ev:any,data:any){
  //   console.log(data)
  //   console.log('handhel essay')
  //   this.checkDataQuestionSeven.push(data)
  //   // this.resultSurvey = this.resultSurvey.filter(item => item.id !== data.id);
  //   if (data.note.length < 5) {
  //     this.errorResultSurvey = "Minimal 5 karakter";
  //   }else{
  //     this.errorResultSurvey = "";
  //   }
  //   if (this.checkDataQuestionSeven.length == 6) {
  //     for (let i = 0; i < this.checkDataQuestionSeven.length; i++) {
  //       const el = this.checkDataQuestionSeven[i];
  //       this.resultSurvey.push(el)
  //     }
  //   }
  // }

  onPrevious(){
    this.questionpage = (Number(this.questionpage)-1) == 0 ? 1 : (Number(this.questionpage)-1);
    this.errorResultSurvey = "";
    // console.log(this.questionpage + 'Sebelum')
    // console.log(this.resultSurvey)
  }

  removeDuplicates(array: string[]): string[] {
    return array.filter((value, index, self) => self.indexOf(value) === index);
  }

  onNext() {
    // console.log(this.questionpage + ' Setelah');
    this.errorResultSurvey = "";

    switch (this.questionpage) {
      case 1:
        if (this.resultSurvey.length === 0) {
          this.errorResultSurvey = "Data wajib diisi.";
        } else {
          const question1 = this.resultSurvey.filter(item => item.linequestion === "1");
          if (question1.length === 0) {
            this.errorResultSurvey = "Data wajib diisi.";
          } else {
            const checkOther = this.resultSurvey.find(item => item.id === "8" && item.linequestion === "1");
            if (checkOther) {
              if (checkOther.note == '') {
                this.errorResultSurvey = "Data wajib diisi.";
              } else {
                this.pagesQuestionNext()
              }
            }else{
              this.pagesQuestionNext()
            }
          }
        }
        break;

      case 2:
        const question2 = this.resultSurvey.filter(item => item.linequestion === "2");
        if (question2.length === 0) {
          this.errorResultSurvey = "Data wajib diisi.";
        } else {
          this.pagesQuestionNext()
        }
        break;

      case 3:
        const question3 = this.resultSurvey.filter(item => item.linequestion === "3");
        if (question3.length === 0) {
          this.errorResultSurvey = "Data wajib diisi.";
        } else {
          this.pagesQuestionNext()
        }
        break;

      case 4:
          const question4 = this.resultSurvey.filter(item => item.linequestion === "4");
          if (question4.length === 0) {
            this.errorResultSurvey = "Data wajib diisi.";
          } else {
            const checkOther = this.resultSurvey.find(item => item.linequestion === "4");
            if (checkOther) {
              if (checkOther.keterangan == '') {
                this.errorResultSurvey = "Data wajib diisi.";
              } else {
                this.pagesQuestionNext()
              }
            }else{
              this.pagesQuestionNext()
            }
          }
        break;

        case 5:
          const question5 = this.resultSurvey.filter(item => item.linequestion === "5");
          if (question5.length === 0) {
            this.errorResultSurvey = "Data wajib diisi.";
          } else {
            this.pagesQuestionNext()
          }
          break;

        case 6:
          const question6 = this.resultSurvey.filter(item => item.linequestion === "6");
          if (question6.length === 0) {
            this.errorResultSurvey = "Data wajib diisi.";
          } else {
            this.pagesQuestionNext()
          }
          break;

        case 7:
            const questionAnswer = this.dataquestion.filter((item: { line: string; }) => item.line === "7");
            for (let index = 0; index < questionAnswer.length; index++) {
              const v = questionAnswer[index];
              for (let i = 0; i < v.options.length; i++) {
                const answer = v.options[i];
                if (answer.note == '') {
                  this.errorResultSurvey = "Data wajib diisi.";
                } else if (answer.note.toLowerCase().includes('pedro')) {
                  this.errorResultSurvey = 'Harap memasukkan brand selain Pedro.';
                } else {
                  // Cek dulu apakah answer dengan id yang sama sudah ada
                  const alreadyExist = this.resultSurvey.some(item => item.id === answer.id);
                  if (!alreadyExist) {
                    this.resultSurvey.push(answer);
                  }
                }
              }
            }

            const question7 = this.resultSurvey.filter(item => item.linequestion === "7");
            // check kembali note kosong dan pedro
            const checkQuestion7 = question7.filter(item => item.note !== '' && item.note.toUpperCase() !== 'PEDRO');
            if (checkQuestion7.length === 6) {
              this.pagesQuestionNext()
            }
          break;

          case 8:
            const question8 = this.resultSurvey.filter(item => item.linequestion === "8");
            if (question8.length === 0) {
              this.errorResultSurvey = "Data wajib diisi.";
            } else {
              const checkOther = this.resultSurvey.find(item => item.linequestion === "8");
              if (checkOther) {
                if (checkOther.keterangan == '') {
                  this.errorResultSurvey = "Data wajib diisi.";
                } else {
                  this.showbuttonclaim = true
                  this.pagesQuestionNext()
                }
              }else{
                this.showbuttonclaim = true
                this.pagesQuestionNext()
              }
            }
            break;

          case 9:
            const question9 = this.resultSurvey.filter(item => item.linequestion === "9");
            if (question9.length === 0) {
              this.errorResultSurvey = "Data wajib diisi.";
            } else {
              this.pagesQuestionNext()
            }
            break;

      default:
        this.pagesQuestionNext()
        break;
    }

    // console.log(this.resultSurvey);
  }

  pagesQuestionNext(){
    this.questionpage = (this.questionpage + 1) === 10 ? 9 : (this.questionpage + 1);
  }


  onSave(){
    this.errorResultSurvey = "";
    // check question 9 final claim
    const question9 = this.resultSurvey.filter(item => item.linequestion === "9");
    if (question9.length === 0) {
      this.errorResultSurvey = "Data wajib diisi.";
    } else {
      // console.log('oke selamat ya ')
      const body = {
        refidotp: this.refidotp,
        dataquestion: this.resultSurvey
      }
      const isData = {
        data: body
      }
      // console.log(isData)
      this.isLoading = true
      this.service.savesurveys(isData).subscribe((r) => {
        if (r.status === 200) {
            this.isLoading = false
            const voucher = r.data.ref_id
            this.goToPage('e?id='+voucher+'&s='+this.isShow)
        }
      }, (e) => {
        this.isLoading = false
        console.error(e)
      })
    }
  }

  goToPage(link: any) {
    this.url.getWindow().open(link, '_self')
  }

}
